import React, { useEffect, useState } from 'react'
import MenuFunzionalita from "./MenuFunzionalita";
import FiltriPerSede from "./FiltriPerSede";
import TabellaOrarioPerSede from "./TabellaOrarioPerSede";
import { Container, Alert, Button } from "react-bootstrap";
import { buildUrl } from '../helper/handler';
import { getFromApi } from '../utilities/NetUtilities';
import ElencoNoteAttiveLavoratore from './ElencoNoteAttiveLavoratore';
import { FaChevronUp, FaChevronRight } from 'react-icons/fa';

function OrarioLavoroSede() {

    const [message, setMessage] = useState([])
    const [filtro, setFiltro] = useState(null)
    const [servizi, setServizi] = useState();
    const [lavoratori, setLavoratori] = useState([])
    const [refreshSettimaneConTurni, setRefreshSettimaneConTurni] = useState(null);
    const [showNotes, setShowNotes] = useState(false);
    const [noteAttive, setNoteAttive] = useState([]);
    const [sedi, setSedi] = useState();

    useEffect(() => {
        const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        const setLavoratoriFromApi = (data) => {
            setLavoratori(data.lavoratori.map(lavoratore => ({
                "value": lavoratore.id,
                "label": lavoratore.nomeCognome
            })));
        }
        const setServiziFromApi = (data) => {
            setServizi(data.servizi);
        }
        const setMessageFromApi = (data) => {
            setMessage(message => [...message, { tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }])
        }
        if (organizzazioneMap) {
            const urlLavoratori = buildUrl(
                'lavoratori',
                {
                    organizzazione: organizzazioneMap.nome,
                    tipo: organizzazioneMap.tipo
                });
            getFromApi(urlLavoratori, setLavoratoriFromApi, setMessageFromApi);
            getFromApi(buildUrl('servizi', { organizzazione: organizzazioneMap.nome, tipo: organizzazioneMap.tipo }), setServiziFromApi, setMessageFromApi)
        }
    }, [])

    useEffect(() => {
        if (filtro && filtro.sede) {
            const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
            const params = {
                organizzazione: organizzazioneMap.nome,
                tipo: organizzazioneMap.tipo,
                sedi: [filtro.sede.value]
            };
            const url = buildUrl('noteattivesede', params);
            const setNoteFromApi = (data) => {
                setNoteAttive(data.note);
                setSedi(data.listasedi);
            };
            const setMessageFromApi = (data) => {
                setMessage(message => [...message, { tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }]);
            };
            getFromApi(url, setNoteFromApi, setMessageFromApi);
        }
    }, [filtro, showNotes]);

    function filtroChanged(newSede, newSettimana) {
        setFiltro({
            sede: newSede,
            settimana: newSettimana
        });
        setShowNotes(false);
        setNoteAttive([]);
    }

    const buildSediMap = () => {
        const sediMap = {};
        if (sedi) {
            sedi.forEach(sede => {
                sediMap[sede.id] = sede.descrizione;
            });
        }
        return sediMap;
    };

    const buildLavoratoriMap = () => {
        const lavoratoriMap = {};
        if (lavoratori) {
            lavoratori.forEach(lavoratore => {
                lavoratoriMap[lavoratore.value] = lavoratore.label;
            });
        }
        return lavoratoriMap;
    };

    return (
        <div className='main' role="main">
            <div>
                <MenuFunzionalita />
                <h1 className="d-flex justify-content-center inEvidenza" id="title_home">Turni di lavoro per sede</h1>
                {
                    message && message.map((data, key) => (
                        <Alert variant={data.tipo} id={`message-${key}`} key={key}>
                            {data.descrizione}
                        </Alert>
                    ))}
                <Container className="">
                    <FiltriPerSede 
                        setMessage={setMessage} 
                        filtroChanged={filtroChanged}
                        refreshSettimaneConTurni={refreshSettimaneConTurni}
                    />
                </Container>
                {filtro && <Container fluid>
                    {noteAttive.length > 0 && (
                        <div className="mb-3 mt-3">
                            <Button
                                variant="flat"
                                size="sm"
                                onClick={() => setShowNotes(!showNotes)}
                                id="note-attive-button"
                                className="btnGeneraleVariante"
                            >
                                Note Attive&nbsp;
                                {showNotes ? <FaChevronUp className="icon-small" /> : <FaChevronRight className="icon-small" />}
                            </Button>
                        </div>
                    )}
                    {showNotes && (
                        <ElencoNoteAttiveLavoratore note={noteAttive} lavoratori={buildLavoratoriMap()} sedi={buildSediMap()} />
                    )}
                </Container>}
                {filtro && <Container fluid>
                    <TabellaOrarioPerSede
                        setMessage={setMessage}
                        settimana={filtro.settimana}
                        sede={filtro.sede}
                        servizi={servizi}
                        lavoratori={lavoratori}
                        setRefreshSettimaneConTurni={setRefreshSettimaneConTurni}
                    />
                </Container>}
            </div>
        </div>
    )
}

export default OrarioLavoroSede;